import { fetchAuthSession } from 'aws-amplify/auth';
import { post, put} from 'aws-amplify/api';
import { useMutation, useQueryClient } from 'react-query';
import { GENERAL_QUERY_KEY } from './useProfileGeneralQuery';


export const PostGeneralMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: 'pcmedapi',
        path: '/profile/general',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GENERAL_QUERY_KEY] });
    },
  });
};

export const PutGeneralMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: 'pcmedapi',
        path: '/profile/general',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GENERAL_QUERY_KEY] });
    },
  });
};
